const RESPONSIVE_WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];

function querySectionFragment(root, selector) {
  const match = root.querySelector(selector);

  if (match) {
    return match;
  }

  for (const template of root.querySelectorAll("template")) {
    const nestedMatch = querySectionFragment(template.content, selector);

    if (nestedMatch) {
      return nestedMatch;
    }
  }

  return null;
}

function imageUrlAtWidth(source, width) {
  const url = new URL(source.startsWith("//") ? `https:${source}` : source, window.location.origin);
  url.searchParams.set("width", width.toString());
  return url.href;
}

function createSecondaryImage(media, currentImage) {
  const preview = media?.preview_image;

  if (!preview?.src) {
    return null;
  }

  const image = currentImage ? currentImage.cloneNode(false) : new Image(preview.width, preview.height);
  const widths = RESPONSIVE_WIDTHS.filter((width) => width <= preview.width);

  image.alt = media.alt || "";
  image.width = preview.width;
  image.height = preview.height;
  image.src = imageUrlAtWidth(preview.src, preview.width);
  image.srcset = widths.map((width) => `${imageUrlAtWidth(preview.src, width)} ${width}w`).join(", ");
  image.loading = "lazy";
  image.fetchPriority = "low";

  if (!currentImage) {
    image.className = "product-card__image product-card__image--secondary object-fill";
  }

  return image;
}

async function updateCardSecondaryImage(input) {
  if (!input.hasAttribute("data-variant-secondary-media")) {
    return;
  }

  const card = input.closest("product-card");
  const currentImage = card?.querySelector(".product-card__image--secondary");
  const primaryImage = card?.querySelector(".product-card__image--primary");

  if (!card || !primaryImage) {
    return;
  }

  const media = JSON.parse(input.getAttribute("data-variant-secondary-media"));
  const nextImage = createSecondaryImage(media, currentImage);

  if (!nextImage || currentImage?.src === nextImage.src) {
    return;
  }

  if (!currentImage) {
    primaryImage.after(nextImage);
    card.classList.add("product-card--show-secondary-media");
    return;
  }

  currentImage.replaceWith(nextImage);
  nextImage.animate({ opacity: [0, 1] }, { duration: 150, easing: "ease-in" });
}

document.addEventListener("pointerover", (event) => {
  const label = event.target.closest(".product-card__swatch-list label, .product-card__variant-list label");
  const input = label?.control;

  if (!input?.hasAttribute("data-variant-secondary-media")) {
    return;
  }

  const media = JSON.parse(input.getAttribute("data-variant-secondary-media"));
  const preload = createSecondaryImage(media, null);

  if (preload) {
    preload.decoding = "async";
  }
}, true);

document.addEventListener("change", (event) => {
  const input = event.target.closest(".product-card__swatch-list input, .product-card__variant-list input");

  if (input) {
    updateCardSecondaryImage(input);
  }
}, true);

document.addEventListener("click", (event) => {
  const label = event.target.closest(".product-card__swatch-list label, .product-card__variant-list label");
  const input = event.target.closest(".product-card__swatch-list input, .product-card__variant-list input") || label?.control;

  if (input) {
    updateCardSecondaryImage(input);
  }
}, true);

function updateGalleryFromSection(event) {
  const fragment = event.detail?.htmlFragment;
  const form = event.target;
  const formId = form?.getAttribute?.("id");

  if (!fragment || !formId) {
    return;
  }

  const formSelector = CSS.escape(formId);
  const incomingGallery = querySectionFragment(fragment, `product-gallery[form="${formSelector}"]`);
  const incomingSwitcher = incomingGallery?.closest("[data-en-gallery-switcher]");
  const currentGallery = document.querySelector(`product-gallery[form="${formSelector}"]`);
  const currentSwitcher = currentGallery?.closest("[data-en-gallery-switcher]");

  if (incomingSwitcher) {
    const incomingKey = incomingSwitcher.getAttribute("data-gallery-key");
    const currentKey = currentSwitcher?.getAttribute("data-gallery-key");

    if (!currentSwitcher || incomingKey !== currentKey) {
      (currentSwitcher || currentGallery)?.replaceWith(incomingSwitcher);
    }
  } else if (currentSwitcher && incomingGallery) {
    currentSwitcher.replaceWith(incomingGallery);
  }
}

document.addEventListener("product:rerender", updateGalleryFromSection, true);

document.querySelectorAll("product-gallery[form]").forEach((gallery) => {
  const form = document.getElementById(gallery.getAttribute("form"));

  if (form && !form.hasAttribute("data-en-gallery-listener")) {
    form.setAttribute("data-en-gallery-listener", "true");
    form.addEventListener("product:rerender", updateGalleryFromSection);
  }
});
